var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.discountProgress.length)?_c('div',{staticClass:"cart-discounts",attrs:{"data-external":"cart-discounts"}},_vm._l((_vm.discountProgress),function(item,i){return _c('CartFreeGiftProgress',{key:`${item.discount.discountId}-${i}`,staticClass:"discount",attrs:{"discount-progress":item}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }